<div class="product-dialog">
  <div class="order-title">
    <div class="flex">
      <p>Order Detail</p>
      <img
        src="assets/images/icons/close-icon.svg"
        alt=""
        class="pointer"
        (click)="closeDialog()"
      />
    </div>
  </div>
  <hr class="custom-hr" />
  <div class="order-detail">
    <div class="text-center flex">
      <img
        class="image-card"
        defaultImage="assets/images/cards/ic_placeholder.png"
        [lazyLoad]="data?.product?.product_detail?.logo"
      />
      <p>
        {{ data?.product?.product_detail?.name }}
        {{ data?.product?.product_detail?.currency_detail?.symbol
        }}{{ data?.product?.item_price | convertPrice }}
      </p>
    </div>
    <div class="detail-row">
      <p class="title">Order ID:</p>
      <p>#{{ data?.product?.order_code }}</p>
    </div>

    <div class="detail-row">
      <p class="title order-info">{{ "summaryPage.qty" | translate }}</p>
      <p>x{{ data?.product?.item_count }}</p>
    </div>
    <div class="detail-row">
      <p class="title order-info">{{ "summaryPage.date" | translate }}</p>
      <p>
        {{ data?.product?.created_time | date : "yyyy.MMM.dd hh:mm a" }}
      </p>
    </div>
    <div class="detail-row">
      <p class="title order-info">{{ "summaryPage.gateway" | translate }}</p>
      <p>{{ data?.product?.gateway_detail?.title || "-" }}</p>
    </div>
    <div class="detail-row">
      <p class="title order-info">Amount:</p>
      <p *ngIf="data?.product?.gateway_detail">
        {{ data?.product?.gateway_detail?.currency_detail?.symbol
        }}{{ data?.product?.payable_amount | convertPrice }}
      </p>
      <p *ngIf="!data?.product?.gateway_detail">
        {{ storeDetail?.currency_detail?.symbol
        }}{{ data?.product?.payable_amount | convertPrice }}
      </p>
    </div>
    <div class="detail-row">
      <p class="title order-info">{{ "summaryPage.delivery" | translate }}</p>
      <p>
        {{ data?.product?.whatsapp }}{{ data?.product?.email
        }}{{ data?.product?.phone }}
      </p>
    </div>
    <div class="detail-row">
      <p class="title order-info">{{ "summaryPage.status" | translate }}</p>

      <div
        class="status-box"
        [ngClass]="{
          'red-status': data?.product.status == -1,
          'green-status': data?.product.status == 6,
          'pending-status': data?.product.status == 5 
        }"
      >
        {{ data?.product?.status_display }}
      </div>
    </div>
    <div class="flex order-actions" *ngIf="data?.product.status != 5 && data?.product.status != 3 && data?.product.status != 8">
      <ng-container *ngIf="data?.product?.status != -1">
        <button class="button transparent-button" type="button" (click)="orderAgain()">
          <span>Order Again</span>
        </button>
        <button class="outline-button" type="button" (click)="resendOrder()">
          <span>Resend Code</span>
        </button>
        <button class="primary-button view-order-button" type="button" (click)="viewOrder(data?.product?.id, 2)">
          <span>View Card </span>
        </button>
      </ng-container>
      <button
        class="outline-button"
        type="button"
        *ngIf="data?.product?.status == -1"
        (click)="orderAgain()"
      >
        <img src="assets/images/icons/reload-blue.svg" alt="" />
        <span>Try Again</span>
      </button>
    </div>
  </div>
</div>

<ng-template #shareLinkDialog>
  <h4>{{ "summaryPage.OrderLink" | translate }}</h4>
  <div class="link-container">
    <a [href]="shareLink" target="_blank">{{ shareLink }}</a>
    <button
      mat-icon-button
      type="button"
      [cdkCopyToClipboard]="shareLink"
      (cdkCopyToClipboardCopied)="tooltip.show()"
    >
      <mat-icon
        ><span class="material-symbols-outlined"> content_copy </span></mat-icon
      >
    </button>
    <span
      #tooltip="matTooltip"
      matTooltip="{{ 'summaryPage.copied' | translate }}"
    ></span>
  </div>
</ng-template>
